/**
 * The block contract.
 *
 * A block owns the conditional logic and produces data. It does not
 * render, does not know its section number, and cannot see its
 * neighbours. That is the whole point: once a block has compiled, its
 * decisions are frozen in the output, so changing (or deleting) the block
 * cannot change a document that was already issued.
 */
import { summarizeEditPolicy } from '../patch/lock.js';
/** `blockKey@version` — the stable way to name one block. */
export const blockRef = (block) => `${block.blockKey}@${block.version}`;
export function parseBlockRef(ref) {
    const at = ref.lastIndexOf('@');
    if (at <= 0 || at === ref.length - 1)
        return null;
    return { blockKey: ref.slice(0, at), version: ref.slice(at + 1) };
}
export function toCatalogBlock(definition) {
    return {
        blockRef: blockRef(definition),
        blockKey: definition.blockKey,
        version: definition.version,
        minor: definition.minor ?? 0,
        plane: definition.plane,
        title: definition.title,
        summary: definition.summary,
        status: definition.status,
        language: definition.language ?? 'sv-SE',
        legalReview: definition.legalReview ?? null,
        slots: definition.slots.map((s) => ({ ...s })),
        editPolicy: summarizeEditPolicy(definition.editPolicy),
    };
}
//# sourceMappingURL=types.js.map